// لماذا تختار حلولنا؟
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import ExtensionRoundedIcon from "@mui/icons-material/ExtensionRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import VolunteerActivismRoundedIcon from "@mui/icons-material/VolunteerActivismRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";

export const WHY_FEATURES = [
  {
    title: "تقارير ذكية فورية",
    desc: "مبيعات، مخزون، مصروفات، أرباح وخسائر — رؤية واضحة تساعدك في اتخاذ القرار.",
    Icon: InsightsRoundedIcon,
  },
  {
    title: "تكامل كامل",
    desc: "إدارة المنتجات والموردين والعملاء، صلاحيات المستخدمين؛ نقاط ولاء وكوبونات خصم.",
    Icon: ExtensionRoundedIcon,
  },

  {
    title: "أمان ونسخ احتياطي",
    desc: "صلاحيات دقيقة ونسخ احتياطي دوري لحماية بياناتك.",
    Icon: SecurityRoundedIcon,
  },
  {
    title: "أجهزة موثوقة",
    desc: "كاشير، طابعات حرارية، ماسحات باركود، درج نقدية، شاشات عرض للعميل.",
    Icon: InventoryRoundedIcon,
  },
  {
    title: "تركيب وتشغيل سريع",
    desc: "نجهزك للانطلاق في وقت قياسي مع تدريب مبسط للموظفين.",
    Icon: AccessTimeRoundedIcon,
  },
  {
    title: "دعم فني مستجيب",
    desc: "دعم عبر الهاتف والواتساب والاتصال عن بُعد طيلة أيام الأسبوع.",
    Icon: VolunteerActivismRoundedIcon,
  },
];

export const WHY_CTA = {
  title: "جاهز للترقية؟",
  subtitle: "انتقل إلى تجربة نقاط بيع أسرع وأكثر دقة .",
  primary: "جرب الان مجانا",
};
